import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Dashboard, Edit, Assignment, AttachMoney, People, SwapHoriz, Campaign, Category, Assessment, ContactMail, Description, FolderOpen, Insights } from '@mui/icons-material';
import { DashboardOutlined, EditOutlined, AssignmentOutlined, AttachMoneyOutlined, PeopleOutlined, SwapHorizOutlined, AssessmentOutlined, ContactMailOutlined, DescriptionOutlined, FolderOpenOutlined, InsightsOutlined } from '@mui/icons-material';
import { newLogo, smallInfluencerLogo, sideSmallLogo } from '../assets/images';

function Sidebar({ activeMenu, setActiveMenu, user, isCollapsed, toggleSidebar }) {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <DashboardOutlined /> },
    { id: 'onboarding', label: 'Onboarding Forms', icon: <EditOutlined /> },
    { id: 'existing', label: user?.role === 'onboarder' ? 'Assigned Influencers' : 'Influencers Assign', icon: <PeopleOutlined /> },
    { id: 'barter', label: 'Barter List', icon: <SwapHorizOutlined /> },
    { id: 'negotiation', label: 'Negotiation Cost', icon: <AttachMoneyOutlined /> },
    { id: 'report', label: 'Report', icon: <AssessmentOutlined /> },
    { id: 'contacts', label: 'Identified Influencers', icon: <ContactMailOutlined /> },
    { id: 'filemanager', label: 'File Manager', icon: <FolderOpenOutlined /> },
    { id: 'iydata', label: 'I & Y Data', icon: <InsightsOutlined /> },
    { id: 'marketing', label: 'Inbox', icon: <Campaign /> },
    { id: 'masters', label: 'Masters', icon: <Category /> }
  ].filter(item => {

    if(user?.role === 'marketing'){
      return item.id === 'marketing' || item.id === 'masters' || item.id === 'dashboard';
    }
    if ( user?.role === 'brand_team' || user?.role === 'dm_team' || user?.role === 'imt_team' || user?.role === 'logistics') {
      return item.id === 'marketing' || item.id === 'dashboard';
    }
    if (item.id === 'existing' && user?.role === 'super_admin') {
      return false;
    }
    if (item.id === 'report' && user?.role !== 'admin') {
      return false;
    }
    if (item.id === 'contacts' && user?.role !== 'admin') {
      return false;
    }
    if (item.id === 'filemanager' && user?.role !== 'admin') {
      return false;
    }
    if ((item.id === 'marketing' || item.id === 'masters') && user?.role !== 'marketing') {
      return false;
    }
    return true;
  });

  return (
    <Box
      sx={{
        width: isCollapsed ? 70 : 210,
        height: '100vh',
        bgcolor: '#1a1d29',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 1000,
        transition: 'width 0.3s ease',
        borderRight: 'none'
      }}
    >
      <Box sx={{ py: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 80 }}>
        {isCollapsed ? (
          <Box
            component="img"
            src={sideSmallLogo}
            alt="Logo"
            sx={{ height: 30, width: 30, borderRadius: '50%', objectFit: 'contain' }}
          />
        ) : (
          <Box
            component="img"
            src={newLogo}
            alt="Logo"
            sx={{ height: "60px", width: "170px", objectFit: 'contain' }}
          />
        )}
      </Box>

      <List sx={{ p: 0, px: 1 }}>
        {menuItems.map(item => (
          <ListItem key={item.id} disablePadding sx={{ my: 0.5 }}>
            <Tooltip title={isCollapsed ? item.label : ''} placement="right" arrow>
              <ListItemButton
                selected={activeMenu === item.id}
                onClick={() => setActiveMenu(item.id)}
                sx={{
                  color: '#a0a3b1',
                  minHeight: '40px',
                  maxHeight: '40px',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  my: 0.5,
                  px: 1.5,
                  '&:hover': {
                    bgcolor: '#252836',
                    color: '#fff'
                  },
                  '&.Mui-selected': {
                    bgcolor: '#DAFF7C',
                    color: '#1a1d29',
                    fontWeight: 600,
                    '& .MuiListItemIcon-root': {
                      color: '#1a1d29',
                    },
                    '&:hover': {
                      bgcolor: '#DAFF7C'
                    }
                  }
                }}
              >
                <ListItemIcon sx={{ color: 'inherit', minWidth: 30 }}>
                  {item.icon}
                </ListItemIcon>
                {!isCollapsed && <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '13px', fontWeight: 500 }} />}
              </ListItemButton>
            </Tooltip>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default Sidebar;
